import { PagedSearch } from '../../shared/model/paged-search.model';

export class RelationTypeSearchParams extends PagedSearch {
  public RelationType: string;
  public RelationDescr: string;
  public InvRelationTypeId: number;
  public InvRelationType: string;
  public InvRelationDescr: string;
  public PrimaryRelation: boolean;
  public ViewMembersOnly: boolean;
  public ViewPublicOnly: boolean;
}
